import Vue from "vue";
import Router from "vue-router";
import firebase from "firebase/app";
import Home from "./views/auth/Home.vue";
import Login from "./views/public/Login";
import PasswordRecover from "./views/public/PasswordRecover";
import Register from "./views/public/Register";
import Installations from "./views/auth/installations/Installations";
import InstallationList from "./views/auth/installations/InstallationList";
import InstallationDetail from "./views/auth/installations/InstallationDetail";
import InstallationWizard from "./views/auth/installations/InstallationWizard";
import InstallationTariff from "./views/auth/installations/InstallationTariff";
import InstallationTemp from "./views/auth/installations/InstallationTemp";
import InstallationStatistics from "./views/auth/installations/InstallationStatistics";
import InstallationQuickSense from "./views/auth/installations/InstallationQuickSense";

import Zone from "./views/auth/installations/zones/Zone";
import ZoneWizard from "./views/auth/installations/zones/ZoneWizard";
import ZoneAdvancedSettings from "./views/auth/installations/zones/ZoneAdvancedSettings";
import ZoneProgram from "./views/auth/installations/zones/ZoneProgram";
import ZoneTemp from "./views/auth/installations/zones/ZoneTemp";
import ZoneStatistics from "./views/auth/installations/zones/ZoneStatistics";

import Device from "./views/auth/installations/devices/Device";
import DeviceAdvancedSettings from "./views/auth/installations/devices/DeviceAdvancedSettings";
import DeviceUserMode from "./views/auth/installations/devices/DeviceUserMode";
import DeviceInfo from "./views/auth/installations/devices/DeviceInfo";
import DeviceProgram from "./views/auth/installations/devices/DeviceProgram";
import DeviceStatistics from "./views/auth/installations/devices/DeviceStatistics";
import DeviceWizard from "./views/auth/installations/devices/DeviceWizard";

import Notifications from "./views/auth/Notifications";
import User from "./views/auth/User";

Vue.use(Router);

let router = new Router({
  mode: "history",
  base: "/home",
  routes: [
    {
      path: "*",
      redirect: "/",
    },
    {
      path: "/",
      redirect: "/installations",
      name: "Installations",
    },
    {
      path: "/login",
      name: "Login",
      component: Login,
    },
    {
      path: "/register",
      name: "Register",
      component: Register,
    },
    {
      path: "/recover",
      name: "Recover",
      component: PasswordRecover,
    },

    {
      path: "/",
      name: "Home",
      component: Home,
      meta: {
        requiresAuth: true,
      },
      children: [
        {
          path: "/notifications",
          name: "Notifications",
          component: Notifications,
        },

        {
          path: "/user",
          name: "User",
          component: User,
        },

        {
          path: "/installations",
          component: Installations,
          children: [
            {
              path: "/",
              component: InstallationList,
            },
            {
              path: "new",
              component: InstallationWizard,
            },
            {
              path: ":id",
              component: InstallationDetail,
              props: true,
            },
            {
              path: ":id/edit",
              component: InstallationWizard,
              props: true,
            },
            {
              path: ":id/tariff",
              component: InstallationTariff,
              props: true,
            },
            {
              path: ":id/temp",
              component: InstallationTemp,
              props: true,
            },

            {
              path: ":id/statistics",
              component: InstallationStatistics,
              props: true,
            },
            {
              path: ":id/quicksense",
              component: InstallationQuickSense,
              props: true,
            },
            {
              path: ":id/zone/add",
              component: ZoneWizard,
              props: true,
              name: "AddZone",
            },
            {
              path: ":id/zone/:idZone",
              component: Zone,
              props: true,
            },
            {
              path: ":id/zone/:idZone/add",
              component: ZoneWizard,
              props: true,
              name: "AddSubZone",
            },
            {
              path: ":id/zone/:idZone/edit",
              component: ZoneWizard,
              props: true,
              name: "EditZone",
            },
            {
              path: ":id/zone/:idZone/settings",
              component: ZoneAdvancedSettings,
              props: true,
            },
            {
              path: ":id/zone/:idZone/program",
              component: ZoneProgram,
              props: true,
            },

            {
              path: ":id/zone/:idZone/statistics",
              component: ZoneStatistics,
              props: true,
            },
            {
              path: ":id/zone/:idZone/temp",
              component: ZoneTemp,
              props: true,
            },
            {
              path: ":id/zone/:idZone/device/:idDevice",
              component: Device,
              props: true,
            },
            {
              path: ":id/zone/:idZone/device/:idDevice/settings",
              component: DeviceAdvancedSettings,
              props: true,
            },
            {
              path: ":id/zone/:idZone/device/:idDevice/usermode",
              component: DeviceUserMode,
              props: true,
            },
            {
              path: ":id/zone/:idZone/device/:idDevice/info",
              component: DeviceInfo,
              props: true,
            },
            {
              path: ":id/zone/:idZone/device/:idDevice/program",
              component: DeviceProgram,
              props: true,
            },
            {
              path: ":id/zone/:idZone/device/:idDevice/statistics",
              component: DeviceStatistics,
              props: true,
            },

            {
              path: ":id/zone/:idZone/device/:idDevice/edit",
              component: DeviceWizard,
              props: true,
            },
          ],
        },
      ],
    },
  ],
});

router.beforeEach((to, from, next) => {
  let currentUser = firebase.auth().currentUser;
  let requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
  if (requiresAuth && !currentUser) next({ name: "Login" });
  else if (!requiresAuth && currentUser) next({ name: "Installations" });
  else next();
});

export default router;
